import React from 'react'
import { PRIORITY_STYLES } from './constants'
import styles from './ProtocolInfographic.module.css'

const BADGE_CLASSES = {
  critical: styles.badgeCritical,
  high: styles.badgeHigh,
  medium: styles.badgeMedium,
  low: styles.badgeLow
}

export default function PriorityBadge({ priority }) {
  if (!priority) {
    return null
  }

  const s = PRIORITY_STYLES[priority]
  const className = `${styles.badge} ${BADGE_CLASSES[priority] || ''}`
  return (
    <span className={className}>
      {priority === 'critical' && <span role="img" aria-label="warning">⚠ </span>}
      {(s && s.label) || priority}
    </span>
  )
}
